import React from 'react';
import { ButtonProps } from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { useTheme } from '@emotion/react';
import { ComposeType } from 'theme/commonStyled';
import { StyledButton } from 'components/Common/MuiButton/style';

export type MuiButtonType = ButtonProps &
  ComposeType & {
    loading?: number;
    disabled?: boolean;
    height?: number;
    variant?:
      | 'blue'
      | 'white'
      | 'dashed'
      | 'berry'
      | 'red'
      | 'green'
      | 'whiteText'
      | 'redText'
      | 'lightBlue'
      | 'transparent'
      | 'blueText'
      | 'danger'
      | 'success'
      | 'lightBerry';
  };

const MuiButton: React.FC<MuiButtonType> = ({
  children,
  loading = false,
  disabled,
  startIcon,
  height,
  variant,
  ...rest
}) => {
  const theme = useTheme();
  return (
    <StyledButton
      startIcon={
        loading ? (
          <CircularProgress
            size={16}
            sx={{ color: 'inherit', marginLeft: '8px' }}
          />
        ) : (
          startIcon
        )
      }
      height={height ? `${theme.sizes[height]}px !important` : 'unset'}
      variant={variant}
      disabled={loading || disabled}
      loading={+loading}
      {...rest}
    >
      {children}
    </StyledButton>
  );
};

export default MuiButton;
